import React from "react";
import PropTypes from "prop-types";
import withStyles from "@material-ui/core/styles/withStyles";

import { palette, typography } from "../../theme/brand";

// Horizontal icon + title + description block, styled from brand tokens.
// Replaces the template `InfoArea` used by the AboutUs sections.
const ICON_COLORS = {
  primary: palette.primary,
  secondary: palette.secondary,
  accent: palette.accent
};

const styles = {
  infoArea: {
    display: "flex",
    alignItems: "flex-start",
    padding: "16px 0",
    textAlign: "left"
  },
  iconWrap: {
    flex: "0 0 auto",
    width: "60px",
    height: "60px",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginRight: "20px"
  },
  icon: {
    fontSize: "32px"
  },
  text: {
    flex: "1 1 auto"
  },
  title: {
    color: palette.textPrimary,
    fontFamily: typography.fontFamilyDisplay,
    fontWeight: 700,
    fontSize: "1.3rem",
    margin: "0 0 10px"
  },
  description: {
    color: palette.textSecondary,
    fontFamily: typography.fontFamilyBase,
    fontSize: "0.95rem",
    lineHeight: 1.7,
    margin: 0
  }
};

function InfoCard({
  classes,
  icon: IconComponent,
  title,
  description,
  iconColor
}) {
  const color = ICON_COLORS[iconColor] || ICON_COLORS.primary;
  return (
    <div className={classes.infoArea}>
      <div
        className={classes.iconWrap}
        style={{ backgroundColor: `${color}1A` }}
      >
        <IconComponent className={classes.icon} style={{ color }} />
      </div>
      <div className={classes.text}>
        <h4 className={classes.title}>{title}</h4>
        <div className={classes.description}>{description}</div>
      </div>
    </div>
  );
}

InfoCard.defaultProps = {
  iconColor: "primary"
};

InfoCard.propTypes = {
  classes: PropTypes.object.isRequired,
  icon: PropTypes.oneOfType([PropTypes.func, PropTypes.object]).isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.node.isRequired,
  iconColor: PropTypes.oneOf(["primary", "secondary", "accent"])
};

export default withStyles(styles)(InfoCard);



// WEBPACK FOOTER //
// ./src/components/ui/InfoCard.jsx